import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { Toaster } from './components/ui/sonner';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ForgotPassword from './pages/ForgotPassword';
import VerifyPhone from './pages/VerifyPhone';
import Dashboard from './pages/Dashboard';
import Upload from './pages/Upload';
import MapView from './pages/MapView';
import Allocate from './pages/Allocate';
import SMS from './pages/SMS';
import Settings from './pages/Settings';
import ErrorLogs from './pages/ErrorLogs';
import './App.css';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-slate-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  return user ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-phone" element={
        <PrivateRoute>
          <VerifyPhone />
        </PrivateRoute>
      } />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />
      <Route path="/trip/:tripId/upload" element={
        <PrivateRoute>
          <Upload />
        </PrivateRoute>
      } />
      <Route path="/trip/:tripId/map" element={
        <PrivateRoute>
          <MapView />
        </PrivateRoute>
      } />
      <Route path="/trip/:tripId/allocate" element={
        <PrivateRoute>
          <Allocate />
        </PrivateRoute>
      } />
      <Route path="/trip/:tripId/sms" element={
        <PrivateRoute>
          <SMS />
        </PrivateRoute>
      } />
      <Route path="/settings" element={
        <PrivateRoute>
          <Settings />
        </PrivateRoute>
      } />
      <Route path="/error-logs" element={
        <PrivateRoute>
          <ErrorLogs />
        </PrivateRoute>
      } />
      <Route path="/" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
